import styled, { css } from 'styled-components';
import breakpoints from '@styles/constants.styled';
import ReactTooltip from 'react-tooltip';
import { EColorScheme } from '@redux/css';

export const StyledSection = styled.section`
  @media screen and ${breakpoints.Device.tablet} {
    padding-left: 0;
  }
`;
export const StyledTooltip = styled(ReactTooltip)`
  max-width: 350px;
  background: var(--theme-StyledTooltip-bgr) !important;
  opacity: 1 !important;
  font-family: Montserrat, serif !important;
  font-weight: 600 !important;
  font-size: 10px !important;
  line-height: 12px !important;
  color: var(--theme-StyledTooltip-color) !important;
  border-radius: 5px !important;
  transition: all 300ms ease-out !important;
  outline: 3px solid var(--theme-StyledTooltip-bgr);
  outline-offset: 5px;
  padding-right: 10px;
  &:after {
    display: none;
  }

  &:before {
    width: calc(100% + 14px) !important;
    height: calc(100% + 14px) !important;
    position: absolute;
    top: -5px !important;
    left: -11px !important;
  }
`;

export const StyledVestingTheme = css`
  &[data-theme='${EColorScheme.DAY}'] {
    ${StyledTooltip} {
      --theme-StyledTooltip-bgr: rgba(249, 198, 189, 1);
      --theme-StyledTooltip-color: rgba(35, 40, 84, 1);
    }
  }

  &[data-theme='${EColorScheme.NIGHT}'] {
    ${StyledTooltip} {
      --theme-StyledTooltip-bgr: #2c2f61;
      --theme-StyledTooltip-color: var(--theme-main-color-inverse);
    }
  }
`;
